/**
 * @summary Adds slider functionality to featured products slider.
 */

/* globals featuredProductsData: true */

import { h, render } from 'preact';
import Slider from './components/Slider';

export default root => {

	// Current DOM children
	const children = Array.from( root.children );

	render( <Slider data={featuredProductsData} />, root );

	// Remove all other DOM children
	children.forEach( element => root.removeChild( element ) );
};



// WEBPACK FOOTER //
// ./src/js/featured-products.js